import { _formatDate } from "../../../../../../libs/dateUtils";

function verefyStateOfResponsabilityOfboolean(props) {
  const { statementOfResponsibility } = props;
  if (statementOfResponsibility == 1) return true;
  return false;
}

function verefyIfExistsValueAndIsNotBoolean(obj: any, i: string) {
  if (obj[i] && i !== "isDeleted" && i !== "statementOfResponsibility") return true;
  return false;
}

function verefyIsBoolean(i: string) {
  if (i === "isDeleted" || i === "statementOfResponsibility") return true;
  return false;
}

function objReceiveKeyAndValue(obj, key, value) {
  return (obj = { ...obj, [`${key}`]: value });
}

export function generateObject(obj, state) {
  let objGerated = {};
  let newObj = {};

  for (let i in obj) {
    const key = [`${i}`];
    const value = obj[i];
    const data = objReceiveKeyAndValue(objGerated, key, value);
    objGerated = data;
  }

  for (let i in objGerated) {
    const key = [`${i}`];
    const value = objGerated[i];
    if (verefyIfExistsValueAndIsNotBoolean(objGerated, i)) {
      const data = objReceiveKeyAndValue(newObj, key, value);
      newObj = data;
    }
    if (verefyIsBoolean(i) && i === "isDeleted") {
      const data = objReceiveKeyAndValue(newObj, key, state);
      newObj = data;
    }
    if (verefyIsBoolean(i) && i !== "isDeleted") {
      const data = objReceiveKeyAndValue(newObj, key, value);
      newObj = data;
    }
    if (i === "status" && objGerated[i] !== "Alocado") {
      newObj["userId"] = null;
      newObj["statementOfResponsibility"] = false;
      newObj["client"] = "";
      newObj["urlStatement"] = "";
    }
  }

  return newObj;
}

export function tratamentObject(obj) {
  let objNew = obj;
  for (let i in obj) {
    const key = [`${i}`];
    if (i === "statementOfResponsibility") {
      const data = objReceiveKeyAndValue(objNew, key, verefyStateOfResponsabilityOfboolean(obj));
      objNew = data;
    }
    if (i === "userId" && obj[i]) {
      const data = objReceiveKeyAndValue(objNew, key, Number(obj[i]));
      objNew = data;
    }
    if (i === "datePurchase") {
      const data = objReceiveKeyAndValue(objNew, key, _formatDate(obj[i]));
      objNew = data;
    }
    if (i === "status" && obj[i] !== "Alocado") {
      objNew["userId"] = null;
      objNew["statementOfResponsibility"] = false;
      objNew["client"] = "";
      objNew["urlStatement"] = "";
    }
  }

  return objNew;
}
